import {Component} from "@angular/core";

@Component({
    selector: "otcx-redirect-only",
    template: "",
})
export class RedirectOnlyComponent {
    // dummy component which is only used for redirecting to a state after login screen
}
